import React from 'react';
import InstitutionForm from '../../../../components/forms/InstitutionForm';

export default function InstitutionsCreatePage() {
  return <InstitutionForm />;
}
